// extracted by mini-css-extract-plugin
export default {"root":"Views_root__+YCyz","content":"Views_content__F11XG"};